import { useQuery } from "@tanstack/react-query";

import api from "../../api";
import { ProjectResource } from "../../types/projectResource";

const useProjectResources = (projectId: string, resourceType: string, newestFirst: boolean = false) => {
  return useQuery({
    queryKey: ['projectResources', projectId],
    queryFn: () => api.projects.resources.getProjectResources(projectId, resourceType),
    select(data) {
      // Newest First
      if (newestFirst) {
        data.body.sort((a,b) => {
          let aTime = new Date(a.creationTime)
          let bTime = new Date(b.creationTime)

          return aTime < bTime ? 1 : -1
        })
      }
      return data.body as Array<ProjectResource>
    }
  })
}

export default useProjectResources
